module.exports = __webpack_public_path__ + "img/so-logo.5f31865e.png";